import { gql, TypedDocumentNode } from '@apollo/client'
import {
  employeeCertificateFragment,
  employeeEducationFragment,
  employeeProfileFragment,
  employeeWorkProfileFragment
} from '@vivaldis/graphql'
import type {
  EmployeeQuery,
  EmployeeQueryVariables
} from './__generated__/EmployeeQuery'

export const employeeQuery: TypedDocumentNode<
  EmployeeQuery,
  EmployeeQueryVariables
> = gql`
  ${employeeCertificateFragment}
  ${employeeEducationFragment}
  ${employeeProfileFragment}
  ${employeeWorkProfileFragment}

  query EmployeeQuery($locale: String!, $brand: BrandsEnum) {
    employee {
      createdAt
      educations {
        ...EmployeeEducationFragment
      }
      email
      employeeCertificates {
        ...EmployeeCertificateFragment
      }
      firstName
      gender
      id
      intentAgreementUrl(brand: $brand)
      isStudent
      lastName
      lastSeenAt
      mobile
      ocrState
      preferredLanguage
      profile {
        ...EmployeeProfileFragment
      }
      ssn
      state
      studentAgreementUrl(brand: $brand)
      updatedAt
      workProfile {
        ...EmployeeWorkProfileFragment
      }
    }
  }
`
